







































import Vue from 'vue';
import { mapState } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import Pagination from '@/components/Pagination.vue';
import Header from '@/components/Header.vue';
import Loading from '@/dex-shared/components/Loading.vue';

export default Vue.extend({
  components: {
    pxCard,
    Header,
    ArrowRightIcon,
    Pagination,
    Loading,
  },

  data() {
    return {
      loaded: true,
      currentPage: 0,
    };
  },

  computed: {
    ...mapState({
      feedbackQuestions: (state: any) =>
        state.feedbackQuestions.feedbackQuestions,
    }),
  },

  async mounted() {
    let page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/perguntas`);
    }
    this.loaded = false;
    this.$store.dispatch('PULL_FEEDBACK_QUESTIONS', this.currentPage);
    this.loaded = true;
  },

  methods: {
    changePage: async function(event: any) {
      this.currentPage = event;
      this.loaded = false;
      await this.$store.dispatch('PULL_FEEDBACK_QUESTIONS', this.currentPage);
      this.loaded = true;
      this.$router.push(`/perguntas/${this.currentPage + 1}`);
    },
  },
});
